import {
  FilePlus,
  LayoutDashboard,
  History,
  UserPlus,
  SpellCheck2,
  BookOpen,
  Database,
  Users,
  Archive,
  GraduationCap,
  FileUp,
  Microscope,
  NotepadText,
  Pointer
} from 'lucide-react'

export const sidebarRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    icon: LayoutDashboard
  },
  {
    path: '/create-test',
    name: 'Create Test',
    icon: FilePlus
  },
  {
    path: '/tests-history',
    name: 'Tests History',
    icon: History
  },
  {
    path: '/create-residence',
    name: 'Create Residence',
    icon: UserPlus
  }
]

export const directorRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: LayoutDashboard
  },
  {
    path: '/dashboard/create-residence',
    name: 'Create Resident',
    icon: UserPlus
  },
  {
    path: '/dashboard/create-exam',
    name: 'Create Exam',
    icon: FilePlus
  },

  {
    path: '/dashboard/residence-table',
    name: 'Your Residents',
    icon: Users
  },
  {
    path: '/dashboard/questions-bank',
    name: 'Questions Bank',
    icon: Archive
  },
  {
    path: '/dashboard/assets',
    name: 'Assets',
    icon: FileUp
  },
  {
    path: '/dashboard/exams',
    name: 'Exams',
    icon: GraduationCap
  }
  // {
  //   path: '/dashboard/reports',
  //   name: 'Reports',
  //   icon: Microscope
  // }
]

export const residenceRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: LayoutDashboard
  },
  {
    path: '/dashboard/create-test',
    name: 'Create Test',
    icon: FilePlus
  },
  {
    path: '/dashboard/tests-history',
    name: 'Tests History',
    icon: History
  },
  {
    path: '/dashboard/mistakes',
    name: 'Your Mistakes',
    icon: SpellCheck2
  },
  {
    path: '/dashboard/marked-questions',
    name: 'Your Notes',
    icon: NotepadText
  },
  {
    path: '/dashboard/enrollments',
    name: 'Enrollments',
    icon: Pointer
  }
  // {
  //   path: '/dashboard/system-reviews',
  //   name: 'System Reviews',
  //   icon: BookOpen
  // }
]
